<template>
  <div class="container flex" style="padding-bottom: 20px;">
    <left></left>
    <input type="file" multiple name="fileImage[]" class="el-upload__input" @change="getpic()" ref="file" style="display: none;" accept=".png,.jpg">
    <div class="live feedback flex1" style="margin-left: 30px;">
    			<div class="title flex padding-15">
    				老师答疑 - <span class="flex1" style="color: #4fa7ff;">去提问</span>
    				<span class="font16" style="color: #4fa7ff;cursor: pointer;" @click="handleBack">返回</span>
    			</div>
    			<div class="flex">
            <div style="width:50%"><div class="" style="padding-left: 15px;margin-top: 15px;">
    				<input type="text" name="" id="" value="" placeholder="标题（10字以内，描述完整清晰）" v-model="answerQuestionsTitle" />
    				<div class="line">

    				</div>
    				<div class="" style="width: 100%;position: relative;">
    					<textarea rows="" cols="" placeholder="详情具体/真实/诚恳的问题会被更快的解答，书籍资料/答题考试等无关的提问会被删除！" v-model="answerQuestionsContent" @change="sliceCotent"></textarea>
    				</div>
    				<div class="line">

    				</div>
    				<div class="font14">
    					请提供问题的截图或照片（选填）
    				</div>
    				<div class="imglist flex">
    						<div class="imgwrap" v-for="item,index in cover">
    							<img :src="item" class="pic" >
    							<img src="../assets/img/delpic.png" class="delpic" @click="handleDelete(index)" >
    						</div>
    						<div class="imgwrap" style="cursor: pointer;" @click="uploadimg()">
    							<img src="../assets/img/addpic.png" >
    						</div>
    				</div>
    				<div class="flex margin-t-15" style="cursor: pointer;" @click="handleMyQustion">
    					<span class="font14 flex1">我的提问</span>
    					<img src="../assets/img/toright.png" width="8" height="19" style="margin-right: 15px;">
    				</div>
    				<div class="line">

    				</div>
    				<div class="btnwrap">
    					<span class="btn" style="cursor: pointer;" @click="handleSubmit">提交</span>
    				</div>
    			</div></div>
            <div></div>
          </div>
    		</div>
        <template v-if="showTips">
          <submitsuccess @closeTips="showTips=false"></submitsuccess>
        </template>
  </div>
</template>

<script>
  import left from './left.vue'
  import submitsuccess from './submitsuccess.vue'
  export default {
    name: 'Footer',
    components:{
      left,
      submitsuccess
    },
    data () {
      return {
          data:'',
          answerQuestionsTitle:'',
          answerQuestionsContent:'',
          answerQuestionsPicture:[],
          cover:[],
          showTips:false
      }
    },
    methods:{
      sliceCotent(){
        if(this.answerQuestionsContent.length>500){
          this.answerQuestionsContent=this.answerQuestionsContent.slice(0,500);
        }
      },
      handleBack(){
        if(window.history.length>1){
          this.$router.go(-1)
        }
        else {
          window.close()
        }
        
      },
      handleDelete(index){
        this.cover.splice(index,1)
      },
      uploadimg:function(){

          document.querySelector('.el-upload__input').click();
      },
      getpic:function(){

              var el=document.querySelector('.el-upload__input');
              this.upload(el.files)
      //    console.log(URL.createObjectURL(el.files[0]))
      //    this.head=URL.createObjectURL(el.files[0]);
      },
      upload(files){
            for(let i=0;i<files.length;i++){
              let data=new FormData();
                  data.append('file',files[i]);
              this.$axios.post(this.$common.upload_url,data).then((res)=>{
                    if(res.data.status=='success'){
                         this.cover.push(res.data.message)
                    }
                    else {
                      alert(res.data.msg)
                    }
              })
            }
      },
      handleMyQustion(){
        this.$router.push('myteacheranswers')
      },
      handleSubmit(){
        if(this.answerQuestionsTitle.length>10){
          alert('标题不能大于10个字符')
          return;
        }
        if(this.answerQuestionsContent==''){
          alert('请输入问题详情')
          return;
        }
        this.submitInfo()


      },
      submitInfo(){
        let data=new FormData();
            data.append('answerQuestionsTitle',this.answerQuestionsTitle);
            data.append('answerQuestionsContent',this.answerQuestionsContent);
            data.append('answerQuestionsPicture',this.cover.join());
        this.$axios.post(this.$common.questions_submit,data).then((res)=>{
              if(res.data.code==1){
                  this.answerQuestionsTitle='';
                  this.answerQuestionsContent=[];
                  this.answerQuestionsPicture=[];
                  this.cover=[];
                  this.showTips=true;
              }
              else {
                alert(res.data.msg)
              }
        })
      }
    },
    created(){

    }
  }
</script>

<style scoped>
  .feedback {
    border: 1px solid silver;
  }
  input {
  	border: none;
    height: 40px;
    width: 100%;
    background: none;
    outline: none;
  }
  textarea {
  	border: none;
  	width: 50%;
  	padding: 15px !important;
  	outline: none;
    background: none !important;

  }
  .pic {
  	width: 80px;
  	height: 80px;
  	object-fit: cover;
  }
  .imglist {
  	margin-top: 15px;
  }
  .imgwrap{
  	margin-right: 15px;
  	position: relative;
  }
  .delpic {
  	position: absolute;
  	right: 2px;
  	top: 2px;
  }
  .live .title, .messageList .title {
  	line-height: inherit;
  }
  .line {
  	background-color: #ccc;
  	height: 1px;
  	margin: 15px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/submitquestion.vue